import { useTranslation } from "react-i18next";
import singleMode from "./filterBaseSingle";
import collatorSort from "utils/collatorSort";

const rawItems = [
	{ key: 1, code: "acting" },
	{ key: 2, code: "active-lifestyle" },
	{ key: 3, code: "aquaristics" },
	{ key: 4, code: "anime-and-manga" },
	{ key: 5, code: "antiques" },
	{ key: 6, code: "architecture" },
	{ key: 7, code: "astrology" },
	{ key: 8, code: "astronomy" },
	{ key: 9, code: "audiobooks" },
	{ key: 10, code: "backpacking" },
	{ key: 11, code: "badminton" },
	{ key: 12, code: "ballet" },
	{ key: 13, code: "barista-skills" },
	{ key: 14, code: "bars-and-pubs" },
	{ key: 15, code: "running" },
	{ key: 16, code: "billiards" },
	{ key: 17, code: "blogging" },
	{ key: 18, code: "boxing" },
	{ key: 19, code: "ceramics" },
	{ key: 20, code: "clubbing" },
	{ key: 21, code: "cosplay" },
	{ key: 22, code: "crossfit" },
	{ key: 23, code: "skateboarding" },
	{ key: 24, code: "djing" },
	{ key: 25, code: "home-comfort" },
	{ key: 26, code: "drinks" },
	{ key: 27, code: "drones" },
	{ key: 28, code: "ecology" },
	{ key: 29, code: "electronics" },
	{ key: 30, code: "fast-food" },
	{ key: 31, code: "feminism" },
	{ key: 32, code: "festivals" },
	{ key: 33, code: "film" },
	{ key: 34, code: "philosophy" },
	{ key: 35, code: "fitness" },
	{ key: 36, code: "photography" },
	{ key: 37, code: "rhythmic-gymnastics" },
	{ key: 38, code: "go-karting" },
	{ key: 39, code: "golf" },
	{ key: 40, code: "cooking" },
	{ key: 41, code: "playing-instruments" },
	{ key: 42, code: "card-games" },
	{ key: 43, code: "computer-graphics" },
	{ key: 44, code: "barbecue" },
	{ key: 45, code: "video-games" },
	{ key: 46, code: "board-games" },
	{ key: 47, code: "mushroom-picking" },
	{ key: 48, code: "history" },
	{ key: 49, code: "hockey" },
	{ key: 50, code: "influencing" },
	{ key: 51, code: "investing" },
	{ key: 52, code: "horseback-riding" },
	{ key: 53, code: "foreign-languages" },
	{ key: 54, code: "yoga" },
	{ key: 55, code: "cabaret" },
	{ key: 56, code: "kayaking" },
	{ key: 57, code: "karaoke" },
	{ key: 58, code: "career" },
	{ key: 59, code: "coffee" },
	{ key: 60, code: "cafes-and-restaurants" },
	{ key: 61, code: "kebab" },
	{ key: 62, code: "camping" },
	{ key: 63, code: "kitesurfing" },
	{ key: 64, code: "collecting" },
	{ key: 65, code: "comics" },
	{ key: 66, code: "concerts" },
	{ key: 67, code: "cosmetology" },
	{ key: 68, code: "basketball" },
	{ key: 69, code: "sewing" },
	{ key: 70, code: "bowling" },
	{ key: 71, code: "criminology" },
	{ key: 72, code: "crosswords" },
	{ key: 73, code: "asian-cuisine" },
	{ key: 74, code: "middle-eastern-cuisine" },
	{ key: 75, code: "homemade-cooking" },
	{ key: 76, code: "indian-cuisine" },
	{ key: 77, code: "mexican-cuisine" },
	{ key: 78, code: "italian-cuisine" },
	{ key: 79, code: "literature" },
	{ key: 80, code: "ice-cream" },
	{ key: 81, code: "luxury" },
	{ key: 82, code: "archery" },
	{ key: 83, code: "ice-skating" },
	{ key: 84, code: "magic" },
	{ key: 85, code: "diy" },
	{ key: 86, code: "makeup" },
	{ key: 87, code: "painting" },
	{ key: 88, code: "monkeys" },
	{ key: 89, code: "massage" },
	{ key: 90, code: "social-media" },
	{ key: 91, code: "natural-medicine" },
	{ key: 92, code: "meditation" },
	{ key: 93, code: "memes" },
	{ key: 94, code: "meat" },
	{ key: 95, code: "military-collectibles" },
	{ key: 96, code: "minimalism" },
	{ key: 97, code: "fashion" },
	{ key: 98, code: "model-making" },
	{ key: 99, code: "motorcycles" },
	{ key: 100, code: "museums" },
	{ key: 101, code: "alternative-music" },
	{ key: 102, code: "country-music" },
	{ key: 103, code: "disco-music" },
	{ key: 104, code: "jazz-music" },
	{ key: 105, code: "classical-music" },
	{ key: 106, code: "metal-music" },
	{ key: 107, code: "pop-music" },
	{ key: 108, code: "rap-music" },
	{ key: 109, code: "rock-music" },
	{ key: 110, code: "techno-music" },
	{ key: 111, code: "skiing" },
	{ key: 112, code: "naturalness" },
	{ key: 113, code: "science" },
	{ key: 114, code: "networking" },
	{ key: 115, code: "nightlife" },
	{ key: 116, code: "diving" },
	{ key: 117, code: "birdwatching" },
	{ key: 118, code: "gardening" },
	{ key: 119, code: "opera" },
	{ key: 120, code: "seafood" },
	{ key: 121, code: "paintball" },
	{ key: 122, code: "baking" },
	{ key: 123, code: "pilates" },
	{ key: 124, code: "football-soccer" },
	{ key: 125, code: "writing" },
	{ key: 126, code: "beer" },
	{ key: 127, code: "pizza" },
	{ key: 128, code: "motorcycle-racing" },
	{ key: 129, code: "swimming" },
	{ key: 130, code: "podcasts" },
	{ key: 131, code: "travel" },
	{ key: 132, code: "poetry" },
	{ key: 133, code: "poker" },
	{ key: 134, code: "pole-dance" },
	{ key: 135, code: "politics" },
	{ key: 136, code: "work" },
	{ key: 137, code: "programming" },
	{ key: 138, code: "entrepreneurship" },
	{ key: 139, code: "nature" },
	{ key: 140, code: "psychology" },
	{ key: 141, code: "puzzles" },
	{ key: 142, code: "atvs-quads" },
	{ key: 143, code: "ramen" },
	{ key: 144, code: "religion" },
	{ key: 145, code: "handicrafts" },
	{ key: 146, code: "parenting" },
	{ key: 147, code: "rollerblading" },
	{ key: 148, code: "farming" },
	{ key: 149, code: "cycling" },
	{ key: 150, code: "personal-development" },
	{ key: 151, code: "rpg-role-playing-games" },
	{ key: 152, code: "rugby" },
	{ key: 153, code: "drawing" },
	{ key: 154, code: "sculpting" },
	{ key: 155, code: "cars" },
	{ key: 156, code: "sauna" },
	{ key: 157, code: "tv-series" },
	{ key: 158, code: "volleyball" },
	{ key: 159, code: "gym" },
	{ key: 160, code: "skydiving" },
	{ key: 161, code: "slow-food" },
	{ key: 162, code: "sweets" },
	{ key: 163, code: "snowboarding" },
	{ key: 164, code: "spa" },
	{ key: 165, code: "walking" },
	{ key: 166, code: "extreme-sports" },
	{ key: 167, code: "meeting-with-friends" },
	{ key: 168, code: "squash" },
	{ key: 169, code: "stand-up-comedy" },
	{ key: 170, code: "shooting" },
	{ key: 171, code: "nail-styling" },
	{ key: 172, code: "surfing" },
	{ key: 173, code: "survival" },
	{ key: 174, code: "sushi" },
	{ key: 175, code: "chess" },
	{ key: 176, code: "champagne" },
	{ key: 177, code: "hookah" },
	{ key: 178, code: "art" },
	{ key: 179, code: "martial-arts" },
	{ key: 180, code: "singing" },
	{ key: 181, code: "dancing" },
	{ key: 182, code: "tarot" },
	{ key: 183, code: "tattoos" },
	{ key: 184, code: "theater" },
	{ key: 185, code: "technology" },
	{ key: 186, code: "television" },
	{ key: 187, code: "tennis" },
	{ key: 188, code: "table-tennis" },
	{ key: 189, code: "conspiracy-theories" },
	{ key: 190, code: "trekking" },
	{ key: 191, code: "triathlon" },
	{ key: 192, code: "jewelry-making" },
	{ key: 193, code: "beauty" },
	{ key: 194, code: "substances" },
	{ key: 195, code: "weekend-getaways" },
	{ key: 196, code: "veganism" },
	{ key: 197, code: "vegetarianism" },
	{ key: 198, code: "fishing" },
	{ key: 199, code: "whisky" },
	{ key: 200, code: "windsurfing" },
	{ key: 201, code: "wine" },
	{ key: 202, code: "volunteering" },
	{ key: 203, code: "climbing" },
	{ key: 204, code: "car-racing" },
	{ key: 205, code: "yerba-mate" },
	{ key: 206, code: "shopping" },
	{ key: 207, code: "healthy-food" },
	{ key: 208, code: "health" },
	{ key: 209, code: "herbalism" },
	{ key: 210, code: "zumba" },
	{ key: 211, code: "sailing" },
	{ key: 212, code: "living-on-the-edge" },
];

export { rawItems };

export const isValidInQuery = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.key);
	const valueAsNumber = Number(value);

	return (
		Number.isInteger(valueAsNumber) &&
		validValuesArray.includes(valueAsNumber)
	);
};

export const isValidInParam = (value) => {
	if (value === "" || value === undefined || value === null) {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.code);

	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.value : null;
	},
	urlToApiParam: (value) => {
		if (!value) return null;
		const current = rawItems.find(({ code }) => code === value)?.key;
		return Number(current);
	},
	queryUrlToApiParam: (queryUrl) => {
		if (!queryUrl) return null;
		const current = rawItems.find(
			({ key }) => key === Number(queryUrl)
		)?.key;
		return Number(current) ?? null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find(({ key }) => key === value)?.code;
		return current ?? "";
	},
	valueToQueryUrl: (value) => {
		const current = rawItems.find(({ key }) => key === Number(value))?.key;
		return current ?? "";
	},
	urlToValue: (url) => {
		const current = rawItems.find(({ code }) => code === url)?.key;
		return current ?? null;
	},
	queryUrlToValue: (queryUrl) => {
		const current = rawItems.find(
			({ key }) => key === Number(queryUrl)
		)?.key;
		return current ?? null;
	},
	queryUrlToUrl: (queryUrl) => {
		const current = rawItems.find(
			({ key }) => key === Number(queryUrl)
		)?.code;
		return current ?? "";
	},
};

const useFilterInterests = ({ initial }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);
	const items = rawItems.map((item) => ({
		content: t(`filtersAndSelectors:interests.${item.key}`),
		value: item.key,
		selected: !(initial === item.key),
		meta: {
			url: item.code,
			value: item.key,
		},
	}));

	const sortedItems = collatorSort(
		collatorSort(items, "content"),
		"selected"
	);

	return {
		rawItems,
		items: sortedItems,
		compute,
		isValidInQuery,
		...singleMode({ items: sortedItems, initial, compute }),
	};
};

export default useFilterInterests;
